let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c02Om")).then(() => parcelRequire('gvzWw'));